var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-1 flex flex-row w-0 overflow-hidden" },
    [
      _c(
        "div",
        { staticClass: "flex-1 flex flex-col w-0 overflow-hidden" },
        [
          _vm.isLoading
            ? _c("Spinner", { staticClass: "d-flex align-items-center h-100" })
            : _c(
                "div",
                { staticClass: "flex flex-col flex-1 overflow-hidden" },
                [
                  _c(
                    "div",
                    { staticClass: "relative shadow-md" },
                    [
                      _c("ChatToolbar", {
                        attrs: { conversation: _vm.conversation }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: " flex-1 overflow-y-auto" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col flex-auto h-full" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col flex-auto flex-shrink-0 rounded-2xl bg-gray-100 h-full"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col h-full overflow-x-auto "
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col h-full" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "chat-scroll",
                                            rawName: "v-chat-scroll",
                                            value: {
                                              always: false,
                                              scrollonremoved: true
                                            },
                                            expression:
                                              "{ always: false, scrollonremoved: true }"
                                          }
                                        ],
                                        staticClass:
                                          "grid grid-cols-12 gap-y-2 overflow-y-auto h-full",
                                        on: { scroll: _vm.onScroll }
                                      },
                                      [
                                        _vm.isLoadingThreads
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-start-1 col-end-13"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-center relative my-2"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "relative text-xs bg-white py-2 px-4 shadow rounded-full text-gray-800"
                                                      },
                                                      [_vm._v(" Loading... ")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(_vm.threads, function(
                                          threadGroup,
                                          dateLabel
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: dateLabel,
                                              staticClass:
                                                "col-start-1 col-end-13"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center relative"
                                                },
                                                [
                                                  _c("hr", {
                                                    staticClass:
                                                      "absolute w-full top-3"
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "relative text-xs bg-white py-2 px-4 shadow rounded-full text-gray-800"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(dateLabel) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._l(threadGroup, function(
                                                thread
                                              ) {
                                                return _c("ThreadItem", {
                                                  key: thread.id,
                                                  attrs: {
                                                    thread: thread,
                                                    conversation:
                                                      _vm.conversation
                                                  },
                                                  on: {
                                                    markAsRead:
                                                      _vm.markThreadAsRead
                                                  }
                                                })
                                              })
                                            ],
                                            2
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("ChatEditor", {
                              attrs: {
                                value: _vm.body,
                                conversation: _vm.conversation
                              },
                              on: { enter: _vm.sendMessage }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
        ],
        1
      ),
      _vm.conversation.customer
        ? _c("InboxRightSidebar", {
            attrs: { conversation: _vm.conversation },
            on: { sendProductUrl: _vm.sendProductUrl }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }